export function normalizeString(text: string): string {
  return text
    .normalize('NFD') // Decompose accented characters
    .replace(/[\u0300-\u036f]/g, '') // Remove diacritics
    .replace(/[^\x00-\x7F]/g, (char) => {
      // Map common special characters manually if they weren't handled by normalization
      const specialCharsMap = new Map<string, string>([
        ['Š', 'S'],
        ['š', 's'],
        ['Ž', 'Z'],
        ['ž', 'z'],
        ['À', 'A'],
        ['Á', 'A'],
        ['Â', 'A'],
        ['Ã', 'A'],
        ['Ä', 'A'],
        ['Å', 'A'],
        ['à', 'a'],
        ['á', 'a'],
        ['â', 'a'],
        ['ã', 'a'],
        ['ä', 'a'],
        ['å', 'a'],
        ['Ç', 'C'],
        ['ç', 'c'],
        ['È', 'E'],
        ['É', 'E'],
        ['Ê', 'E'],
        ['Ë', 'E'],
        ['è', 'e'],
        ['é', 'e'],
        ['ê', 'e'],
        ['ë', 'e'],
        ['Ì', 'I'],
        ['Í', 'I'],
        ['Î', 'I'],
        ['Ï', 'I'],
        ['ì', 'i'],
        ['í', 'i'],
        ['î', 'i'],
        ['ï', 'i'],
        ['Ñ', 'N'],
        ['ñ', 'n'],
        ['Ò', 'O'],
        ['Ó', 'O'],
        ['Ô', 'O'],
        ['Õ', 'O'],
        ['Ö', 'O'],
        ['ò', 'o'],
        ['ó', 'o'],
        ['ô', 'o'],
        ['õ', 'o'],
        ['ö', 'o'],
        ['Ù', 'U'],
        ['Ú', 'U'],
        ['Û', 'U'],
        ['Ü', 'U'],
        ['ù', 'u'],
        ['ú', 'u'],
        ['û', 'u'],
        ['ü', 'u'],
        ['Ý', 'Y'],
        ['ý', 'y'],
        ['ÿ', 'y'],
        ['Æ', 'AE'],
        ['æ', 'ae'],
        ['Ø', 'O'],
        ['ø', 'o'],
        ['Œ', 'OE'],
        ['œ', 'oe'],
      ]);

      return specialCharsMap.get(char) || char;
    });
}
